/**
 * Shared DayPicker inline styles for custom date range dialogs (fixed range and until-now).
 * Used by CustomFixedRangePicker and SingleDatePicker.
 */
export const sharedDayPickerStyles = {
  month_caption: {
    fontWeight: 500,
    color: '#444',
    textTransform: 'capitalize' as const,
  },
  weekday: {
    textTransform: 'uppercase' as const,
  },
  selected: {
    fontWeight: 500,
  },
  range_start: {
    fontWeight: 500,
  },
  range_middle: {
    fontWeight: 500,
  },
  range_end: {
    fontWeight: 500,
  },
};
